import { ReadableUploadSource } from "../../base-types";
import { IUploadSource } from "../../contracts/upload/upload-source";
import Guard from "../../guard";

export class ArrayBufferUploadSource implements IUploadSource {
    constructor(
        private buffer: ArrayBuffer,
        name: string
    ) {
        Guard.notNull(buffer);
        Guard.stringNotNullOrEmpty(name);

        this.name = name;
    }

    name: string;

    getReadableSourceAsync(): Promise<ReadableUploadSource> {
        return Promise.resolve(this.buffer);
    }
}
